import { QuestionOption } from '@models/product';

/** CommerceOptionModal / CommercePayment 에서 사용 (희망 일정 제외) */
export const getModalQuestionOptions = (questionOptions?: QuestionOption[]) => {
  return (questionOptions || []).filter((option) => option.questionType !== 'preferredSchedule');
};
